export default __webpack_public_path__ + "static/thumbnail-643054f4b7cee3fe971d89891e2f00ab.png";